module.exports = __webpack_public_path__ + "static/img/xp-btn.4c2de0e1.png";